/**
 * kc-product
 * Variant switching (no reload), quantity stepper, add to cart, wishlist,
 * description clamp, sticky mobile bar, and a small custom lightbox.
 */
(function () {
	'use strict';

	function money(cents) {
		try {
			return window.themeCore && window.themeCore.utils && window.themeCore.utils.formatMoney
				? window.themeCore.utils.formatMoney(cents, window.themeCore.objects.settings.money_format)
				: (cents / 100).toFixed(2);
		} catch (e) {
			return (cents / 100).toFixed(2);
		}
	}

	function initInstance(root) {
		if (!root || root.__kcProductInit) return;
		root.__kcProductInit = true;

		var dataScript = root.querySelector('[data-kc-product-data]');
		if (!dataScript) return;
		var data;
		try {
			data = JSON.parse(dataScript.textContent);
		} catch (e) {
			return;
		}

		var variants = data.variants || [];
		var selectedOptions = {};
		var initialVariant = variants.find(function (v) { return v.id === data.selectedVariantId; });
		if (initialVariant) {
			initialVariant.options.forEach(function (val, i) {
				selectedOptions[i + 1] = val;
			});
		}

		function findVariant() {
			return variants.find(function (v) {
				return v.options.every(function (val, i) {
					var wanted = selectedOptions[i + 1];
					return wanted === undefined || wanted === val;
				});
			});
		}

		// --- Options (swatches + buttons) -------------------------------------
		var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-kc-swatch], [data-kc-option-button]'));

		function updateOptionUI() {
			optionButtons.forEach(function (btn) {
				var pos = btn.getAttribute('data-option-position');
				var val = btn.getAttribute('data-value');
				var selected = selectedOptions[pos] === val;
				btn.classList.toggle('is-selected', selected);
			});

			root.querySelectorAll('[data-kc-option]').forEach(function (optionEl) {
				var pos = optionEl.getAttribute('data-option-position');
				var valueEl = optionEl.querySelector('[data-kc-option-value]');
				if (valueEl && selectedOptions[pos] !== undefined) {
					valueEl.textContent = selectedOptions[pos];
				}
			});
		}

		function applyVariant(variant, options) {
			var form = root.querySelector('[data-kc-product-form]');
			var priceEl = root.querySelector('[data-kc-price-current]');
			var priceWrap = root.querySelector('[data-kc-price]');
			var stockEl = root.querySelector('[data-kc-stock]');
			var stockText = root.querySelector('[data-kc-stock-text]');
			var addButton = root.querySelector('[data-kc-add-to-cart]');
			var addLabel = root.querySelector('[data-kc-add-to-cart-label]');
			var stickyPrice = root.querySelector('[data-kc-sticky-price]');

			if (!variant) {
				if (addButton) addButton.disabled = true;
				if (addLabel) addLabel.textContent = ((window.KC_I18N && KC_I18N.unavailable) || 'Unavailable');
				return;
			}

			var variantIdInput = form && form.querySelector('[data-kc-variant-id]');
			if (variantIdInput) variantIdInput.value = variant.id;

			if (priceEl) priceEl.textContent = money(variant.price);
			if (stickyPrice) stickyPrice.textContent = money(variant.price);
			if (priceWrap) {
				var compareEl = priceWrap.querySelector('[data-kc-price-compare]');
				var onSale = variant.compareAtPrice && variant.compareAtPrice > variant.price;
				priceWrap.classList.toggle('kc-price--sale', !!onSale);
				if (onSale) {
					if (!compareEl) {
						compareEl = document.createElement('span');
						compareEl.className = 'kc-price__compare';
						compareEl.setAttribute('data-kc-price-compare', '');
						priceWrap.insertBefore(compareEl, priceWrap.querySelector('.kc-price__tax'));
					}
					compareEl.textContent = money(variant.compareAtPrice);
				} else if (compareEl) {
					compareEl.remove();
				}
			}

			if (stockEl) stockEl.classList.toggle('is-soldout', !variant.available);
			if (stockText) stockText.textContent = variant.available ? ((window.KC_I18N && KC_I18N.inStock) || 'In stock') : ((window.KC_I18N && KC_I18N.temporarilyOut) || 'Temporarily out of stock');
			if (addButton) addButton.disabled = !variant.available;
			if (addLabel) addLabel.textContent = variant.available ? ((window.KC_I18N && KC_I18N.addToCart) || 'Add to cart') : ((window.KC_I18N && KC_I18N.soldOut) || 'Sold out');

			try {
				var url = new URL(window.location.href);
				url.searchParams.set('variant', variant.id);
				window.history.replaceState({}, '', url);
			} catch (e) { /* ignore */ }

			if (variant.featuredMediaId) {
				var mediaItem = root.querySelector('[data-kc-gallery-item][data-media-id="' + variant.featuredMediaId + '"]');
				var gallery = root.querySelector('[data-kc-gallery]');
				if (mediaItem && gallery && mediaItem.parentElement === gallery) {
					gallery.insertBefore(mediaItem, gallery.firstChild);
				}
			}
		}

		optionButtons.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var pos = btn.getAttribute('data-option-position');
				var val = btn.getAttribute('data-value');
				selectedOptions[pos] = val;
				updateOptionUI();
				applyVariant(findVariant(), selectedOptions);
			});
		});

		var swatchMore = root.querySelector('[data-kc-swatch-more]');
		if (swatchMore) {
			swatchMore.addEventListener('click', function () {
				var wrap = swatchMore.closest('[data-kc-swatches]');
				var expanded = wrap.classList.toggle('is-expanded');
				wrap.querySelectorAll('.kc-swatch--extra').forEach(function (el) {
					el.hidden = !expanded;
				});
				swatchMore.textContent = expanded ? ((window.KC_I18N && KC_I18N.showFewer) || 'Show fewer') : '+' + wrap.querySelectorAll('.kc-swatch--extra').length;
			});
		}

		// --- Quantity ----------------------------------------------------------
		var qtyInput = root.querySelector('[data-kc-qty-input]');
		var qtyMinus = root.querySelector('[data-kc-qty-minus]');
		var qtyPlus = root.querySelector('[data-kc-qty-plus]');
		if (qtyMinus && qtyInput) {
			qtyMinus.addEventListener('click', function () {
				qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
			});
		}
		if (qtyPlus && qtyInput) {
			qtyPlus.addEventListener('click', function () {
				qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
			});
		}

		// --- Add to cart ---------------------------------------------------------
		var form = root.querySelector('[data-kc-product-form]');
		var addButton = root.querySelector('[data-kc-add-to-cart]');
		var addLabel = root.querySelector('[data-kc-add-to-cart-label]');

		function submitAddToCart() {
			if (!form || addButton.disabled) return;
			var variantIdInput = form.querySelector('[data-kc-variant-id]');
			var id = variantIdInput ? variantIdInput.value : null;
			var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
			if (!id) return;

			addButton.disabled = true;
			var originalLabel = addLabel ? addLabel.textContent : '';

			// Always a plain fetch, never window.themeCore.CartApi — that API's
			// own ADD_TO_CART action also pops open the theme's native cart
			// drawer as a side effect, which would show up stacked behind our
			// own drawer (see kc-cart-drawer.js).
			var addPromise = fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
			});

			addPromise
				.then(function () {
					addButton.classList.add('is-added');
					if (addLabel) addLabel.textContent = ((window.KC_I18N && KC_I18N.added) || 'Added ✓');
					document.dispatchEvent(new CustomEvent('kc:cart:added'));
					setTimeout(function () {
						addButton.classList.remove('is-added');
						if (addLabel) addLabel.textContent = originalLabel;
						addButton.disabled = false;
					}, 1800);
				})
				.catch(function () {
					addButton.disabled = false;
				});
		}

		if (form) {
			form.addEventListener('submit', function (event) {
				event.preventDefault();
				submitAddToCart();
			});
		}

		var stickyAdd = root.querySelector('[data-kc-sticky-add]');
		if (stickyAdd) {
			stickyAdd.addEventListener('click', submitAddToCart);
		}

		// --- Wishlist ------------------------------------------------------------
		var wishlistBtn = root.querySelector('[data-kc-wishlist]');
		if (wishlistBtn) {
			var handle = wishlistBtn.getAttribute('data-handle');
			function getWishlist() {
				try {
					return JSON.parse(localStorage.getItem('kc-wishlist') || '[]');
				} catch (e) {
					return [];
				}
			}
			function setWishlist(list) {
				try {
					localStorage.setItem('kc-wishlist', JSON.stringify(list));
				} catch (e) { /* ignore */ }
			}
			function refreshWishlistUI() {
				var active = getWishlist().indexOf(handle) > -1;
				wishlistBtn.classList.toggle('is-active', active);
				wishlistBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
			}
			wishlistBtn.addEventListener('click', function () {
				var list = getWishlist();
				var index = list.indexOf(handle);
				if (index > -1) {
					list.splice(index, 1);
				} else {
					list.push(handle);
				}
				setWishlist(list);
				refreshWishlistUI();
			});
			refreshWishlistUI();
		}

		// --- Description clamp / read more ----------------------------------------
		// Two separate elements, not a class toggle: the clamped preview is
		// always flattened plain text (WebKit's -webkit-line-clamp mis-renders
		// multi-paragraph HTML — see the liquid comment above this markup), and
		// "Läs mer" swaps to the real multi-paragraph HTML instead of just
		// lifting the clamp on the same node.
		var descriptionClamped = root.querySelector('[data-kc-description-clamped]');
		var descriptionFull = root.querySelector('[data-kc-description-full]');
		var descriptionToggle = root.querySelector('[data-kc-description-toggle]');
		if (descriptionClamped && descriptionFull && descriptionToggle) {
			var descriptionExpanded = false;
			function checkOverflow() {
				var overflowing = descriptionClamped.scrollHeight > descriptionClamped.clientHeight + 1;
				descriptionToggle.hidden = !overflowing && !descriptionExpanded;
			}
			descriptionToggle.addEventListener('click', function () {
				descriptionExpanded = !descriptionExpanded;
				descriptionClamped.hidden = descriptionExpanded;
				descriptionFull.hidden = !descriptionExpanded;
				descriptionToggle.setAttribute('aria-expanded', descriptionExpanded ? 'true' : 'false');
				descriptionToggle.textContent = descriptionExpanded ? ((window.KC_I18N && KC_I18N.showLess) || 'Show less') : ((window.KC_I18N && KC_I18N.readMore) || 'Read more');
				if (!descriptionExpanded) {
					var label = root.querySelector('.kc-description__label');
					if (label) label.scrollIntoView({ block: 'nearest' });
				}
			});
			checkOverflow();
			window.addEventListener('resize', checkOverflow);
		}

		// --- Sticky add-to-cart bar (mobile) --------------------------------------
		var stickyBar = root.querySelector('[data-kc-sticky-bar]');
		var mainAddButton = root.querySelector('[data-kc-add-to-cart]');
		if (stickyBar && mainAddButton && 'IntersectionObserver' in window) {
			var stickyObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
				});
			}, { threshold: 0 });
			stickyObserver.observe(mainAddButton);
		}

		// --- Gallery counter (mobile swipe) ---------------------------------------
		var gallery = root.querySelector('[data-kc-gallery]');
		var counter = root.querySelector('[data-kc-gallery-counter]');
		if (gallery && counter && 'IntersectionObserver' in window) {
			var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-kc-gallery-item]'));
			var galleryObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
						var index = items.indexOf(entry.target);
						if (index > -1) counter.textContent = (index + 1) + ' / ' + items.length;
					}
				});
			}, { root: gallery, threshold: 0.6 });
			items.forEach(function (item) { galleryObserver.observe(item); });
		}

		// --- Lightbox --------------------------------------------------------------
		var lightbox = root.querySelector('[data-kc-lightbox]');
		if (lightbox && gallery) {
			var lightboxImage = lightbox.querySelector('[data-kc-lightbox-image]');
			var galleryItems = function () {
				return Array.prototype.slice.call(gallery.querySelectorAll('[data-kc-gallery-item]'));
			};
			var currentIndex = 0;

			function openLightbox(index) {
				var list = galleryItems();
				currentIndex = ((index % list.length) + list.length) % list.length;
				var src = list[currentIndex].getAttribute('data-full-src');
				if (!src) return;
				lightboxImage.src = src;
				lightbox.classList.add('is-open');
				lightbox.setAttribute('aria-hidden', 'false');
				document.body.style.overflow = 'hidden';
			}

			function closeLightbox() {
				lightbox.classList.remove('is-open');
				lightbox.setAttribute('aria-hidden', 'true');
				document.body.style.overflow = '';
			}

			gallery.addEventListener('click', function (event) {
				var item = event.target.closest('[data-kc-gallery-item]');
				if (!item) return;
				openLightbox(galleryItems().indexOf(item));
			});

			var closeBtn = lightbox.querySelector('[data-kc-lightbox-close]');
			var prevBtn = lightbox.querySelector('[data-kc-lightbox-prev]');
			var nextBtn = lightbox.querySelector('[data-kc-lightbox-next]');
			if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
			if (prevBtn) prevBtn.addEventListener('click', function () { openLightbox(currentIndex - 1); });
			if (nextBtn) nextBtn.addEventListener('click', function () { openLightbox(currentIndex + 1); });
			lightbox.addEventListener('click', function (event) {
				if (event.target === lightbox) closeLightbox();
			});
			document.addEventListener('keydown', function (event) {
				if (!lightbox.classList.contains('is-open')) return;
				if (event.key === 'Escape') closeLightbox();
				if (event.key === 'ArrowLeft') openLightbox(currentIndex - 1);
				if (event.key === 'ArrowRight') openLightbox(currentIndex + 1);
			});
		}

		updateOptionUI();
	}

	function initAll(context) {
		var scope = context || document;
		scope.querySelectorAll('.kc-main-product').forEach(initInstance);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { initAll(); });
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});
})();
